import React, { Fragment, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { download } from '../Actions/DownloadButton.action';
import { translate } from '../Services/translation';

const DownloadButton = props => {
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const downloadPdf = useCallback(async (articleNumber) => {
        setLoading(true);
        try {
            // dispatch may return a promise (thunk). Await if it does.
            const res = dispatch(download(articleNumber));
            if (res && typeof res.then === 'function') {    
                await res;
            }
        } finally {
            setLoading(false);
        }
    }, [dispatch]);

    return (
        <Fragment>
            {loading ? (
                <button className="actions__btn button btn-black btn-loading w-100" type="button" disabled>
                    <span className="spinner-border" aria-hidden="true"></span>
                    {translate('product.generate-pdf')}
                </button>
            ) : (
                <a
                    className="actions__btn btn-black"
                    onClick={() => downloadPdf(props.articleNumber)}
                >
                    <svg
                        id="download"
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                    >
                        <rect
                            id="Rectangle_198"
                            data-name="Rectangle 198"
                            width="22"
                            height="2"
                            transform="translate(2 24)"
                            fill="#fff"
                        />
                        <path
                            id="Path_53"
                            data-name="Path 53"
                            d="M11.347,22.2a2.337,2.337,0,0,0,3.306,0L26,10.15,24.855,9.09,13.78,20.847V0H12.22V20.847L1.145,9.09,0,10.15,11.326,22.173Z"
                            fill="#fff"
                        />
                    </svg>
                    {translate('product.download')}
                </a>
            )}
        </Fragment>
    );
};

export default DownloadButton;